import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const CREATE_CUSTOM_PAGE: DocumentNode = gql`
  mutation createCustomPage($input: CreateCustomPageInput!) {
    createCustomPage(input: $input)
  }
`;

export const DELETE_PAGE: DocumentNode = gql`
  mutation deletePage($id: Int!) {
    deletePage(id: $id)
  }
`;

export const SET_PAGE_PUBLICATION_STATUS: DocumentNode = gql`
  mutation setPagePublicationStatus($id: Int!, $isPublished: Boolean!) {
    setPagePublicationStatus(id: $id, isPublished: $isPublished) {
      id
      isHidden
    }
  }
`;

export const EDIT_CUSTOM_PAGE: DocumentNode = gql`
  mutation editCustomPage($id: Int!, $input: EditCustomPageInput!) {
    editCustomPage(id: $id, input: $input) {
      id
      pageNavTitle
      isHidden
      isExclude
      bannerFile {
        id
        hash
        extension
        url
        name
      }
      translations {
        id
        communityId
        field
        iso
        objectId
        objectType
        value
      }
      panels {
        id
        settings {
          __typename
          ... on TextPanelSettings {
            type
            size
            text
            buttonConfig {
              display
              category
              text
              url
              externalUrl
              targetType
            }
          }
          ... on ImagePanelSettings {
            type
            size
            imageFile {
              id
              hash
              extension
              url
              name
            }
            imageWidth
            imageAltText
            imageRoundedCorners
            buttonConfig {
              display
              category
              text
              url
              externalUrl
              targetType
            }
          }
          ... on VideoPanelSettings {
            type
            size
            embed
            videoUrl
            videoEmbedCode
          }
          ... on IdeasPanelSettings {
            type
            size
            ideasDisplay: display
            ideasDefault: default
            timespan
          }
          ... on LeaderboardPanelSettings {
            type
            size
            leaderboardDisplay: display
            leaderboardDefault: default
          }
          ... on ChallengeCarouselPanelSettings {
            type
            size
            favourites
            hideDescription
            includeUserChallenges
          }
          ... on LinePanelSettings {
            type
            size
          }
          ... on ActivityPanelSettings {
            type
            size
          }
          ... on BlogCarouselPanelSettings {
            type
            size
          }
        }
      }
    }
  }
`;
